<template>
  <div class='year atb-flex atb-flex-column'>
    <div class='header atb-flex atb-flex-items-center'>
      <div class='year-title'>
        <h2 v-if="summaryData.year">{{ summaryData.year }}{{ periods[summaryData.period] }} / {{ summaryData.wkName }}</h2>
        <span class="saveStatus">{{ saveStatus }}</span>
      </div>
    </div>
    <div class='container search-and-content atb-content-bg atb-flex atb-flex-column' id="year-wrap">
      <div class="search">
        <div class="function atb-flex">
          <el-form :inline="true" class="atb-input">
            <el-form-item v-if="isEditable && !isPublished">
              <el-button :disabled="pending" type="primary" @click="saveAll">保存</el-button>
            </el-form-item>
            <el-form-item v-if="isEditable && !isPublished">
              <el-button :disabled="pending" type="downloadTemplate" plain @click="confirmScore()">确认</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" plain @click="exportExcel">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button plain type="downloadTemplate" @click="expandRowAll">{{expandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <div v-show="showCollapse" class="collapse" @click="collapse($refs.year, tableColumn)">
          <i :class="[isCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          class='atb-table header-table edit-table border-table disable-ellipsis'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="tableData"
          ref="year"
          :merge-cells="mergeCells"
          :row-class-name="setRowClass"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @edit-actived="activeRow"
          @cell-click="expandRow"
          :edit-rules="validRules"
          :scroll-y="{enabled: false}"
        >
          <vxe-table-column field="workItemNo" min-width="50" width="50" title="NO." align="center">
            <template #default="scope">
              <template v-if="scope.rowIndex === 0">
                <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                     <i @click="expandKpi" :class="[expandKpiStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                     <span @click="expandKpi">重要KPI</span>
                  </div>
                </div>
              </template>
              <span v-else-if="scope.rowIndex < kpiLength + 1">{{scope.rowIndex}}</span>
              <template v-else-if="scope.rowIndex === kpiLength + 1">
                <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandNormal" :class="[expandNormalStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandNormal">业务工作</span>
                  </div>
                </div>
              </template>
              <span v-else-if="scope.rowIndex > kpiLength + 1 && scope.rowIndex < normalLength + kpiLength + 2">{{scope.rowIndex - kpiLength - 1}}</span>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + 2">
                <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandCreate" :class="[expandCreateStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandCreate">费效管理</span>
                  </div>
                </div>
              </template>
              <span v-else-if="scope.rowIndex > normalLength + kpiLength + 2 && scope.rowIndex < normalLength + kpiLength + createLength + 3">{{scope.rowIndex - kpiLength - normalLength - 2}}</span>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + 3">
                <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandHr" :class="[expandHrStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandHr">人力资源</span>
                  </div>
                </div>
              </template>
              <span v-else-if="scope.rowIndex > normalLength + kpiLength + createLength + 3 && scope.rowIndex < normalLength + kpiLength + createLength + hrLength + 4">{{scope.row.workItemNo}}</span>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + hrLength + 4">
                <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandCc" :class="[expandCcStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandCc">企业文化</span>
                  </div>
                </div>
              </template>
              <span v-else-if="scope.rowIndex > normalLength + kpiLength + createLength + hrLength + 4 && scope.rowIndex < normalLength + kpiLength + createLength + hrLength + ccLength + 5">{{scope.row.workItemNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemCategory" min-width="80" title="类别">
             <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.workItemCategory}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" title="工作项目" min-width="100" width="150">
            <template #default="scope">
              <div :class="[scope.row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{scope.row.workItemContent}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="fullTarget" min-width="100" title="全年目标" width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.fullTarget}}</div>
            </template>
          </vxe-table-column>
           <vxe-table-column field="resWkName" min-width="120" title="责任人(工号)">
            <template #default="{ row }">
              <span>{{ row.resWkName }}</span>
              <span>({{ row.resWkNo }})</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="weight" min-width="80" title="权重(%)">
            <template #default="{ row }">
              <span>{{row.weight}}</span>
            </template>
          </vxe-table-column>

          <vxe-table-column field="startDate" title="开始日期" min-width="100">
            <template #default="{ row }">{{ formatDate(row.startDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>

          <vxe-table-column field="finishDate" title="最终完成日期" min-width="120">
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>

          <vxe-table-column field="target" min-width="120" width="150" title="上半年目标" v-if="summaryData.period === 6.5">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.target}}</div>
            </template>
          </vxe-table-column>

          <vxe-table-column field="summary" min-width="120" width="150" title="上半年总结" v-if="summaryData.period === 6.5">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.summary}}</div>
            </template>
          </vxe-table-column>

          <vxe-table-column field="target" min-width="100" width="150" title="全年目标" v-if="summaryData.period === 13">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.target}}</div>
            </template>
          </vxe-table-column>

          <vxe-table-column field="summary" min-width="100" width="150" title="全年总结" v-if="summaryData.period === 13">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.summary}}</div>
            </template>
          </vxe-table-column>

          <vxe-table-column v-if="isApprove || isPublished" field="appraise" min-width="200" title="评价" :edit-render="{enabled: enabledAppraise, autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.appraise}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.appraise" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>

          <vxe-table-column
            v-if="isApprove || isPublished"
            min-width="140"
            field="score"
            :controls="false"
            title="评分"
            :edit-render="{ enabled: enabledScore, autofocus: '.el-input__inner' }"
          >
            <template #edit="{ row }">
              <el-autocomplete @change="regScore(row, 'score')" v-model.trim="row.score" :fetch-suggestions="scoreSearch"></el-autocomplete>
            </template>
            <template #header="{ column }">
              <div style="display: inline-block;">
                <span>{{ column.title }}</span>
                <span>(</span>
                <el-popover
                  width="600"
                  trigger="hover"
                >
                  <span slot="reference" class="rank-tip">评分标准</span>
                  <table class="rank-tip-table">
                    <thead>
                      <tr>
                        <th width="60" align="center">标准</th>
                        <th width="80" align="center">分值区间</th>
                        <th align="center">标准说明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td align="center">出色</td>
                        <td align="center">100</td>
                        <td>工作绩效始终超越本职位常规标准要求，通常具有下列表现：在规定的时间之前完成任务，完成任务的数量、质量等明显超出规定的标准，得到来自客户的高度评估。</td>
                      </tr>
                      <tr>
                        <td align="center">优良</td>
                        <td align="center">90</td>
                        <td>工作绩效经常超出本职位常规标准要求，通常具有下列表现：严格按照规定的时间要求完成任务并经常提前完成任务，经常在数量、质量上超出规定的标准，获得客户的满意。</td>
                      </tr>
                      <tr>
                        <td align="center">可接受</td>
                        <td align="center">80</td>
                        <td>工作绩效经常维持或偶尔超出本职位常规标准要求，通常具有下列表现；基本上达到规定的时间、数量、质量等工作标准，没有客户不满。</td>
                      </tr>
                      <tr>
                        <td align="center">需改进</td>
                        <td align="center">70</td>
                        <td>需改进，工作绩效基本维持或偶尔未达本职位常规标准要求，通常具有下列表现：偶有小的疏漏，有时在时间、数量、质量上达不规定的工作标准，偶尔有客户的投诉。</td>
                      </tr>
                      <tr>
                        <td align="center">不良</td>
                        <td align="center">60<br/>30<br/>0</td>
                        <td>工作绩效显著低于常规本职位正常工作标准的要求，通常具有下列表现：工作中出现大的失误，或在时间、数量、质量上达不到规定的工作标准，经常突击完成任务、经常有投诉发生。</td>
                      </tr>
                    </tbody>
                  </table>
                </el-popover>
                <span>)</span>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column
            v-if="isApprove || isPublished"
            min-width="140"
            field="weightMultiplyScore"
            :controls="false"
            title="得分"
            :edit-render="{ enabled: enabledWeightScore, autofocus: '.el-input__inner' }"
            class-name="weight-score"
          >
            <template #edit="{ row }">
              <el-autocomplete @change="regScore(row, 'weightMultiplyScore')" v-model.trim="row.weightMultiplyScore" :fetch-suggestions="scoreSearch"></el-autocomplete>
            </template>
            <template #header="{ column }">
              <div style="display: inline-block;">
                <span>{{ column.title }}</span>
                <span>(</span>
                <el-popover
                  width="600"
                  trigger="hover"
                >
                  <span slot="reference" class="rank-tip">评分标准</span>
                  <table class="rank-tip-table">
                    <thead>
                      <tr>
                        <th width="60" align="center">标准</th>
                        <th width="80" align="center">分值区间</th>
                        <th align="center">标准说明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td align="center">出色</td>
                        <td align="center">100</td>
                        <td>工作绩效始终超越本职位常规标准要求，通常具有下列表现：在规定的时间之前完成任务，完成任务的数量、质量等明显超出规定的标准，得到来自客户的高度评估。</td>
                      </tr>
                      <tr>
                        <td align="center">优良</td>
                        <td align="center">90</td>
                        <td>工作绩效经常超出本职位常规标准要求，通常具有下列表现：严格按照规定的时间要求完成任务并经常提前完成任务，经常在数量、质量上超出规定的标准，获得客户的满意。</td>
                      </tr>
                      <tr>
                        <td align="center">可接受</td>
                        <td align="center">80</td>
                        <td>工作绩效经常维持或偶尔超出本职位常规标准要求，通常具有下列表现；基本上达到规定的时间、数量、质量等工作标准，没有客户不满。</td>
                      </tr>
                      <tr>
                        <td align="center">需改进</td>
                        <td align="center">70</td>
                        <td>需改进，工作绩效基本维持或偶尔未达本职位常规标准要求，通常具有下列表现：偶有小的疏漏，有时在时间、数量、质量上达不规定的工作标准，偶尔有客户的投诉。</td>
                      </tr>
                      <tr>
                        <td align="center">不良</td>
                        <td align="center">60<br/>30<br/>0</td>
                        <td>工作绩效显著低于常规本职位正常工作标准的要求，通常具有下列表现：工作中出现大的失误，或在时间、数量、质量上达不到规定的工作标准，经常突击完成任务、经常有投诉发生。</td>
                      </tr>
                    </tbody>
                  </table>
                </el-popover>
                <span>)</span>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column v-if="isApprove || isPublished" field="remark" min-width="200" title="备注" :edit-render="{enabled: enabledRemark, autofocus: '.el-textarea__inner'}">
            <template #default="{row, rowIndex}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center', isRemarkTitleRow(rowIndex) ? 'kpi-add' : '']">{{row.remark}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.remark" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
  </div>
</template>
<script>
  import qs from 'qs'
  import XEUtils from 'xe-utils'
  import _ from 'lodash';
  import {
  PERIODS,
} from '@/utils/period-enum.js';

  export default {
    name: "workscoreYearDetail",
    data() {
      const appraiseValid = ({cellValue, rowIndex}) => {
        if (rowIndex > 0 && rowIndex <= this.kpiLength && !cellValue) {
          return new Error('"评价"为必填项');
        }
      };
      const scoreValid = ({cellValue, rowIndex}) => {
        if (rowIndex > 0 && rowIndex <= this.kpiLength && !cellValue && cellValue !== 0) {
          return new Error('"评分"为必填项');
        }
      };
      const weightScoreValid = ({cellValue, rowIndex}) => {
        if (rowIndex === this.kpiLength + 1 && !cellValue && cellValue !== 0 && (this.normalLength > 0 || this.cloneNormal.length > 0)) {
          return new Error('"得分"为必填项');
        }
      };
      return {
        toUrl: '',
        periods: PERIODS,
        validRules: {
          appraise: [
            { required: true, validator: appraiseValid, message: '"评价"为必填项' }
          ],
          score: [
            { required: true, validator: scoreValid, message: '"评分"为必填项' }
          ],
          weightMultiplyScore: [
            { required: true, validator: weightScoreValid, message: '"得分"为必填项' }
          ],
        },
        summaryData: {},
        workId: '',
        childIds: "",

        workClassifyData: null,

        enabledAppraise: true,
        enabledScore: true,
        enabledWeightScore: true,
        enabledRemark: true,
 
        enabled: true,
        mergeCells: [
          {row: 0, col: 0, rowspan: 1, colspan: 14},
          {row: 1, col: 0, rowspan: 1, colspan: 14},
          {row: 2, col: 0, rowspan: 1, colspan: 14},
          {row: 3, col: 0, rowspan: 1, colspan: 14},
          {row: 4, col: 0, rowspan: 1, colspan: 14},
        ],
        result: {},
        kpi: [],
        normal: [],
        create: [],
        hr:[],
        cc:[],

        status: 0,

        riskControl:[], //风控
        employee:[], //人才梯队建设
        salary:[], //薪酬管理
        oec:[], //OEC管理
        employ:[], //招聘管理
        train:[], //培训管理
        employeeRelation:[], //员工关系

        orgBuild:[], //组织建设
        culTrain:[], //文化培训
        culIntegral:[], //文化积分
        culSpread:[], //文化传播
        culActivity:[], //文化活动
        culPublicity:[], //文化宣贯

        tableColumn: [],

        expandKpiStatus: true,
        expandNormalStatus: true,
        expandCreateStatus: true,
        expandHrStatus:true,
        expandCcStatus:true,
        expandPgStatus:true,
        expandOtherStatus:true,

        cloneKpi:[],
        cloneNormal:[],
        cloneCreate:[],
        cloneHr:[],
        cloneCc:[],
        clonePg:[],
        cloneOther:[],

        scoreKpi:[],
        scoreNormal:[],
        scoreCreate:[],
        scoreHr:[],
        scoreCc:[],
        scorePg:[],
        scoreOther:[],
        totalScore: {},

        cloneTableData: [],
        row: {},
        timer: null,
        rowIndex: 0,
        editStatus:'',
        saveStatus:'',
        timeoutSave:'',
        timeoutAutoSave:'',
        isCollapse: false,
        showCollapse: false,
        pending: false,
        autoSaving: false, //是否在自动保存中
        isPreventSave: false, //是否阻止了自动保存
        expandRowAllFlag: false,

        scoreList: [{ value: 100 }, { value: 90 }, { value: 80 }, { value: 70 }, { value: 60 }, { value: 30 }, { value: 0 }],
      }
    },
    computed: {
      //重要KPI
      kpiLength() { //kpi数据长度 动态增加数据使用
        return this.kpi.length;
      },
      //业务工作
      normalLength() {
        return this.normal.length;
      },
      //费效管理
      createLength() {
        return this.create.length;
      },
      //人力资源
      hrLength() {
        return this.hr.length;
      },
      //企业文化
      ccLength() {
        return this.cc.length;
      },

      tableData() {
        return [
          {isTitle: true, weightMultiplyScore: this.totalScore[0], workClassify: 0},
          ...this.kpi,
          {isTitle: true, weightMultiplyScore: this.totalScore[10], workClassify: 10},
          ...this.normal,
          {isTitle: true, weightMultiplyScore: this.totalScore[20], workClassify: 20},
          ...this.create,
          {isTitle: true, weightMultiplyScore: this.totalScore[30], workClassify: 30},
          ...this.hr,
          {isTitle: true, weightMultiplyScore: this.totalScore[40], workClassify: 40},
          ...this.cc,
        ];
      },
      //风控
      riskControlLength() { //风控数据长度 动态增加数据使用
        return this.riskControl.length;
      },
      //人才梯队建设
      employeeLength() { //人才梯队建设数据长度 动态增加数据使用
        return this.employee.length;
      },
      //薪酬管理
      salaryLength() {
        return this.salary.length;
      },
       //OEC管理
      oecLength() {
        return this.oec.length;
      },
       //招聘管理
      employLength() {
        return this.employ.length;
      },
       //培训管理
      trainLength() {
        return this.train.length;
      },
       //员工关系
      employeeRelationLength() {
        return this.employeeRelation.length;
      },
       //组织建设
      orgBuildLength() {
        return this.orgBuild.length;
      },
       //文化培训
      culTrainLength() {
        return this.culTrain.length;
      },
       //文化积分
      culIntegralLength() {
        return this.culIntegral.length;
      },
       //文化传播
      culSpreadLength() {
        return this.culSpread.length;
      },
       //文化活动
      culActivityLength() {
        return this.culActivity.length;
      },
       //文化宣贯
      culPublicityLength() {
        return this.culPublicity.length;
      },
      tableColumnLength() {
        return this.tableColumn.length;
      },

      isApprove() {
        // 上级进行评分
        return this.editStatus === 'approve';
      },
      isEditable() {
        return this.isApprove && [0, 10, 30].includes(this.status);
      },

      isPublished() {
        return this.status === 50;
      },

      isCanBack() {
        return this.status === null || !this.isApprove || [20, 40, 50].includes(this.status);
      }
      // 已保存0，已引入10，上级已确认20，外部已确认30，已确认40，已公示50
    },
    created() {
      this.workId = this.$route.query.id || '';
      this.status = parseInt(this.$route.query.status) || 0;
      this.editStatus = this.$route.query.editStatus || '';
      this.msgId = this.$route.query.msgId || null;
      this.childIds = this.$route.query.childIds? this.$route.query.childIds.split(','): null;
      this.from = this.$route.query.from || '';
      this.workId && this.getList();
    },
    mounted(){
      this.$nextTick(() => {
        this.tableColumn = (this.$refs.year && this.$refs.year.getColumns()) || [];
        this.$refs.year && this.$refs.year.refreshColumn();
      });

      if (window.history && window.history.pushState) {
        window.addEventListener("popstate", this.goBack, false); // 回退时执行goback方法
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (from.name && !vm.$store.state.common.isBack) {
          vm.$store.commit('common/pushNavList', {
            url: from.fullPath,
            name: from.meta.title,
          });
        }
        vm.$store.commit('common/updateIsBack'); 
      })
    },
    beforeRouteLeave(to, from, next) {
      if (this.isCanBack) {
        this.toUrl = to.fullPath;
        if(Object.keys(to.query).length===0) this.$store.commit('common/emptyNavList');
        next(true);
      } else {
        next(false);
        this.$message.warning('请先确认评分');
        if (to.name === 'OEC.Period.WorkScore' && this.$store.state.common.navList.findIndex(item => item.url === to.fullPath) === -1) {
          if (to.name && !this.$store.state.common.isBack) {
            this.$store.commit('common/pushNavList', {
              url: to.fullPath,
              name: to.meta.title,
            });
          }
          this.$store.commit('common/updateIsBack'); 
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    destroyed() {
      window.removeEventListener("popstate", this.goBack, false);
    },
    methods: {
      regScore(row, score) {
        let val = row[score];
        if(!val) val = '';
        val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        val = val && parseFloat(val);
        if (val - 0 > 100) {
          val = 100;
        }
        if (val - 0 < 0) {
          val = 0;
        }
        if (val === '') val = null;
        row[score] = val;
      },
      scoreSearch(queryString, cb) {
        let programList = this.scoreList;
        // 调用 callback 返回建议列表的数据
        cb(programList);
      },
      collapse(el) {
        this.isCollapse = !this.isCollapse;
        if (this.isCollapse) {
          el && el.refreshColumn();
        }else {
          el && el.refreshColumn();
        }
      },

      async getList() {
        let param = Object.assign({ScoreId: this.workId})
        await this.$ajax.get(this.$api.period.workScore.yearScoreList +'?'+ qs.stringify(param, {indices: false})).then((res) => {
          let tableData = [];
          if(res.data){
            let resList = res.data.listReturnDtos;
            let totalScore = {};
            resList.forEach(item => {
              totalScore[item.workClassify] = item.score;
              if (item.workClassify !== 0) {
                item.yearItemScoreEntities.forEach(r => {
                  r.appraise = item.appraise;
                  r.remark = item.remarks;
                });
              }
              tableData.push(...item.yearItemScoreEntities);

            });
            this.totalScore = totalScore;
            this.workClassifyData = resList;
            this.filterTableData(tableData);
            this.summaryData = res.data.yearScoreEntity;
            this.status = this.summaryData.status;
            this.$nextTick(() => {
              this.tableColumn = this.$refs.year.getColumns();
              setTimeout(() => {
                this.setMerge();
              }, 0);
            });
          }
          if (!res.data || tableData === 0) {
            this.tableData = [{}, {}, {}, {}, {}];
          }
        }).catch(()=>{
          this.status = null;
        });
      },
      filterTableData(tableData) {
        this.kpi = tableData.filter(val => !val.isTitle && val.workClassify == 0);
        this.normal = tableData.filter(val => !val.isTitle && val.workClassify == 10);
        this.create = tableData.filter(val => !val.isTitle && val.workClassify == 20);
        this.hr = tableData.filter(val => !val.isTitle && val.workClassify == 30).sort(this.itemSort);
        this.cc = tableData.filter(val => !val.isTitle && val.workClassify == 40).sort(this.itemSort);
        this.calcHrWeight(this.hr);
        this.calcCCheight(this.cc);
      },
      calcCCheight(data) {
        this.orgBuild = data.filter(t => t.workItemCategory === "组织建设");
        this.culTrain = data.filter(t => t.workItemCategory === "文化培训");
        this.culIntegral = data.filter(t => t.workItemCategory === "文化积分");
        this.culSpread = data.filter(t => t.workItemCategory === "文化传播");
        this.culActivity = data.filter(t => t.workItemCategory === "文化活动");
        this.culPublicity = data.filter(t => t.workItemCategory === "文化宣贯");
      },
      calcHrWeight(data){
        this.riskControl = data.filter(t => t.workItemCategory === "风控");
        this.riskControl.forEach(item => {
          item.weightTemp = this.riskControl.map(p => p.weight).reduce((prev, cur) => prev + cur);
        });
        this.employee = data.filter(t => t.workItemCategory === "人才梯队建设");
        this.employee.forEach(item => {
          item.weightTemp = this.employee.map(p => p.weight).reduce((prev, cur) => prev + cur);
        });
        this.salary = data.filter(t => t.workItemCategory === "薪酬管理");
        this.salary.forEach(item => {
          item.weightTemp = this.salary.map(p => p.weight).reduce((prev, cur) => prev + cur);
        });
        this.oec = data.filter(t => t.workItemCategory === "OEC管理");
        this.oec.forEach(item => {
          item.weightTemp = this.oec.map(p => p.weight).reduce((prev, cur) => prev + cur);
        });
        this.employ = data.filter(t => t.workItemCategory === "招聘管理");
        this.employ.forEach(item => {
          item.weightTemp = this.employ.map(p => p.weight).reduce((prev, cur) => prev + cur);
        });
        this.train = data.filter(t => t.workItemCategory === "培训管理");
        this.train.forEach(item => {
          item.weightTemp = this.train.map(p => p.weight).reduce((prev, cur) => prev + cur);
        });
        this.employeeRelation = data.filter(t => t.workItemCategory === "员工关系");
        this.employeeRelation.forEach(item => {
          item.weightTemp = this.employeeRelation.map(p => p.weight).reduce((prev, cur) => prev + cur);
        });
      },
      
      setRowClass({rowIndex}) {
        if (rowIndex == 0 || rowIndex == this.kpiLength + 1 || rowIndex == this.kpiLength + this.normalLength + 2 || rowIndex == this.kpiLength + this.normalLength + this.createLength + 3 || rowIndex == this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4) {
          return 'main-row';
        }
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format)
      },

      saveFn(row, index) {
        this.pending = true;
        // 重要KPI 每项
        if (index > 0 && index < this.kpiLength + 1) {
          return this.$ajax.post(this.$api.period.workScore.yearScoreUpdate,  [this.tableData[index]], {noLoading:true}).then((res) => {
            if (res.data && res.data.updateEntities && res.data.updateEntities[0]) {
              const item = res.data.updateEntities[0];
              row.weightMultiplyScore = item.weightMultiplyScore;
            }
            if (res.data && res.data.periodClassifyScoreImportantKPI) {
              this.totalScore[res.data.periodClassifyScoreImportantKPI.workClassify] = res.data.periodClassifyScoreImportantKPI.score;
            }
            
            this.$nextTick(() => {
              this.setMerge();
            });
          }).finally(()=>{
            this.pending = false;
          });
        } else {
          // 业务工作 得分、评价、备注
          let params = {
            "wkNo": this.summaryData.wkNo,
            "wkName": this.summaryData.wkName,
            "year": this.summaryData.year,
            "period": this.summaryData.period,
            "workClassify": this.tableData[index].workClassify,
            "score": null,
          };

          if (index === this.kpiLength + 1) {
            let normalData = this.normal;
            if (!this.expandNormalStatus) {
              normalData = this.cloneNormal;
            }
            params.score = this.tableData[index].weightMultiplyScore;
            params.appraise = normalData[0] ? normalData[0].appraise : '';
            params.remarks = normalData[0] ? normalData[0].remark : '';
            this.totalScore[params.workClassify] = params.score;
            this.$nextTick(() => {
              this.setMerge();
            });
          } else if (index > this.kpiLength + 1 && index < this.kpiLength + this.normalLength + 2) {
            params.score = this.tableData[this.kpiLength + 1].weightMultiplyScore;
            params.appraise = this.tableData[index].appraise;
            params.remarks = this.tableData[index].remark;
          }
          return this.$ajax.post(this.$api.period.workScore.updateYearScore, params, {noLoading:true}).finally(()=>{
            // this.totalScore[params.workClassify] = ''
            this.pending = false;
          });
        }
      },

      save(row, index) {
        if (this.autoSaving) {
          this.isPreventSave = true;
        } else {
          this.saveFn(row, index).then(() => {
            this.saveStatus = "已保存";
            this.timeoutSave && clearTimeout(this.timeoutSave);
            this.timeoutSave = setTimeout(()=>{
              this.saveStatus = "";
            }, 1000, this);
            clearInterval(this.timer);
          });
        } 
      },
      saveAuto(row, index) {
        this.autoSaving = true;

        this.saveFn(row, index).then(() => {
          this.saveStatus = "已保存";
          this.timeoutAutoSave && clearTimeout(this.timeoutAutoSave);
          this.timeoutAutoSave = setTimeout(() => {
            this.saveStatus = "";
          }, 1000, this);
          if(this.isPreventSave) {
            this.save(row, index);
          }
        }).finally(() => {
          this.autoSaving = false;
        });
      },

      saveAll() {
        if (this.kpiLength === 0 && this.normalLength === 0) {
          return this.$message.warning('当前没有需要保存的数据');
        }
        if (this.kpiLength > 0) {
          this.$ajax.post(this.$api.period.workScore.yearScoreUpdate,  this.tableData.slice(1, this.kpiLength + 1), {noLoading:true}).then((res) => {
            if (res.code == 0){
              this.$message.success('保存成功');
            } else {
              this.$message.error(res.message);
            }
          });
        }
        if (this.normalLength > 0) {
          const params = {
            "wkNo": this.summaryData.wkNo,
            "wkName": this.summaryData.wkName,
            "year": this.summaryData.year,
            "period": this.summaryData.period,
            "workClassify": 10,
            "score": this.tableData[this.kpiLength + 1].weightMultiplyScore,
            "appraise": this.tableData[this.kpiLength + 2].appraise,
            "remarks": this.tableData[this.kpiLength + 2].remarks,
          };
  
          this.$ajax.post(this.$api.period.workScore.updateYearScore, params, {noLoading:true})
        }
      },
      
      isRemarkTitleRow(rowIndex) {
        return rowIndex === 0 ||
          rowIndex === this.kpiLength + 1 ||
          rowIndex === this.kpiLength + this.normalLength + 2 ||
          rowIndex === this.kpiLength + this.normalLength + this.createLength + 3 ||
          rowIndex === this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4
      },
      editClosed({rowIndex}) {
        this.enabledAppraise = true;
        this.enabledScore = true;
        this.enabledWeightScore = true;
        this.enabledRemark = true;
        clearInterval(this.timer);
        if (rowIndex !== -1) {
          if (this.isEditable && rowIndex > 0 && rowIndex < this.kpiLength + this.normalLength + 2) {
            if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = false;
            this.$refs.year.updateData(this.tableData);
            this.save(this.tableData[rowIndex], rowIndex);
          }
        }
      },
      activeRow({row, rowIndex}) {
        clearInterval(this.timer);
        if (rowIndex > this.kpiLength + this.normalLength + 1) return 0;
        if (this.isEditable) {
          this.timer = setInterval(() => {
            this.saveAuto(row, rowIndex);
          }, 10000)
        }
      },

  
      editActived({rowIndex}) {
        if (this.isEditable) {
          // 可编辑状态
          if (rowIndex > 0 && rowIndex <= this.kpiLength) {
            this.enabledScore = true;
          } else {
            this.enabledScore = false;
          }

          if (rowIndex === this.kpiLength + 1 && (this.normalLength > 0 || this.cloneNormal.length > 0)) {
            this.enabledWeightScore = true;
          } else {
            this.enabledWeightScore = false;
          }
          if (
            (rowIndex > 0 && rowIndex < this.kpiLength + 1) ||
            (rowIndex > this.kpiLength + 1 && rowIndex < this.kpiLength + this.normalLength + 2)
          ) {
            this.enabledAppraise = true;
            this.enabledRemark = true;
          } else {
            this.enabledRemark = false;
            this.enabledAppraise = false;
          }
        } else {
          this.enabledAppraise = false;
          this.enabledScore = false;
          this.enabledWeightScore = false;
          this.enabledRemark = false;
        }
        return true;
      },

      itemSort(a, b){
        return a.workItemNo - b.workItemNo;
      },
      // 确认分数
      confirmScore(){
        this.expandAll();
        this.setMerge();
        this.$nextTick(async ()=>{
          const $table = this.$refs.year
          const errMap = await $table.validate(this.tableData).catch(errMap => errMap)
          if (errMap) {
            const msgList = []
            Object.values(errMap).forEach(errList => {
              errList.forEach(params => {
                const { rules } = params;
                rules.forEach(rule => {
                  // msgList.push(`第 ${rowIndex + 1} 行 ${column.title} 校验错误：${rule.message}`)
                  msgList.push(`${rule.message}`)
                })
              })
            })
            this.$message({
              type: 'error',
              message: msgList.join()
            })
          } else {
            this.$ajax.get(this.$api.period.workScore.yearScoreConfirm, { ScoreId: this.workId }).then((res) => {
              if(res.code == 0){
                this.$message.success('提交成功');
                this.getList();
              }else{
                this.$message.error(res.message);
              }
            });
          }
        });
      },
      expandKpi() {
        this.setMerge();
        this.expandKpiStatus = !this.expandKpiStatus;
        if (this.expandKpiStatus) {
          this.kpi = _.cloneDeep(this.cloneKpi);
        } else {
          this.cloneKpi = _.cloneDeep(this.kpi);
          this.kpi = [];
        }
      },
      expandNormal() {
        this.setMerge();
        this.expandNormalStatus = !this.expandNormalStatus;
        if (this.expandNormalStatus) {
          this.normal = _.cloneDeep(this.cloneNormal);
        } else {
          this.cloneNormal = _.cloneDeep(this.normal);
          this.normal = [];
        }
      },
      expandCreate() {
        this.setMerge();
        this.expandCreateStatus = !this.expandCreateStatus;
        if (this.expandCreateStatus) {
          this.create = _.cloneDeep(this.cloneCreate);
        } else {
          this.cloneCreate = _.cloneDeep(this.create);
          this.create = [];
        }
      },
      expandHr() {
        this.setMerge();
        this.expandHrStatus = !this.expandHrStatus;
        if (this.expandHrStatus) {
          this.hr = _.cloneDeep(this.cloneHr);
        } else {
          this.cloneHr = _.cloneDeep(this.hr);
          this.hr = [];
        }
      },
      expandCc() {
        this.setMerge();
        this.expandCcStatus = !this.expandCcStatus;
        if (this.expandCcStatus) {
          this.cc = _.cloneDeep(this.cloneCc);
        } else {
          this.cloneCc = _.cloneDeep(this.cc);
          this.cc = [];
        }
      },
      expandAll(){
       if (!this.expandKpiStatus) {
          this.expandKpiStatus = !this.expandKpiStatus;
          this.kpi = _.cloneDeep(this.cloneKpi);
       }
        if (!this.expandNormalStatus) {
          this.expandNormalStatus = !this.expandNormalStatus;
          this.normal = _.cloneDeep(this.cloneNormal);
        }
      if (!this.expandCreateStatus) {
          this.expandCreateStatus = !this.expandCreateStatus;
          this.create = _.cloneDeep(this.cloneCreate);
        }
       if (!this.expandHrStatus) {
          this.expandHrStatus = !this.expandHrStatus;
          this.hr = _.cloneDeep(this.cloneHr);
        }
       if (!this.expandCcStatus) {
          this.expandCcStatus = !this.expandCcStatus;
          this.cc = _.cloneDeep(this.cloneCc);
        }
      },
      

      expandRow({rowIndex}) {
        if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.year.updateData(this.tableData);
      },
      expandRowAll() {
        if (this.expandRowAllFlag) {
          this.tableData.forEach(val => {
            val.expandRowFlag = false;
          }); 
        } else {
          this.tableData.forEach(val => {
            val.expandRowFlag = true;
          });
        }
        this.expandRowAllFlag = !this.expandRowAllFlag;
        this.$refs.year.updateData(this.tableData);

        // this.$nextTick(() => {
        //   let scrollInfo = this.$refs.year.getScroll();
        //   this.$refs.year.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
        // });
      },

      setMerge() {
        const $table = this.$refs.year;
        const workItemNoColIndex = $table? $table.getColumns().map(p=>p.property).indexOf("workItemNo"): -1;
        const workItemCategoryColIndex = $table? $table.getColumns().map(p=>p.property).indexOf("workItemCategory"): -1;
        // const weightColIndex = $table? $table.getColumns().map(p=>p.property).indexOf("weight"): -1;
        const titleColumnLength = 12;
        this.mergeCells = [
          {row: 0, col: 0, rowspan: 1, colspan: 12},
          {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: titleColumnLength},
          {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: titleColumnLength},
          {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: titleColumnLength},
          {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4, col: 0, rowspan: 1, colspan: titleColumnLength},
          {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5, col: 0, rowspan: 1, colspan: titleColumnLength},
          
          // 合并评价列
          {row: this.kpiLength + 2, col: 10, rowspan: this.normalLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + 3, col: 10, rowspan: this.createLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + this.createLength + 4, col: 10, rowspan: this.hrLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: 10, rowspan: this.ccLength, colspan: 1},
          // 合并评分列
          {row: this.kpiLength + 2, col: 11, rowspan: this.normalLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + 3, col: 11, rowspan: this.createLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + this.createLength + 4, col: 11, rowspan: this.hrLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: 11, rowspan: this.ccLength, colspan: 1},
          // 合并得分列
          {row: this.kpiLength + 2, col: 12, rowspan: this.normalLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + 3, col: 12, rowspan: this.createLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + this.createLength + 4, col: 12, rowspan: this.hrLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: 12, rowspan: this.ccLength, colspan: 1},

          // 合并备注列
          {row: this.kpiLength + 2, col: 13, rowspan: this.normalLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + 3, col: 13, rowspan: this.createLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + this.createLength + 4, col: 13, rowspan: this.hrLength, colspan: 1},
          {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: 13, rowspan: this.ccLength, colspan: 1},

        ];

        if (this.hrLength > 0) {
          this.mergeCells.push(...[
            //人力资源第一列合并(NO.)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemNoColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemNoColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemNoColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemNoColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemNoColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            //人力资源第二列合并(类别)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemCategoryColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemCategoryColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemCategoryColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemCategoryColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemCategoryColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            // //人力资源第六列合并(权重)
            // {row: this.kpiLength + this.normalLength + this.createLength + 4, col: weightColIndex, rowspan: this.riskControlLength, colspan: 1},
            // {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: weightColIndex, rowspan: this.employeeLength, colspan: 1},
            // {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: weightColIndex, rowspan: this.oecLength, colspan: 1},
            // {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: weightColIndex, rowspan: this.trainLength, colspan: 1},
            // {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: weightColIndex, rowspan: this.employeeRelationLength, colspan: 1},
          ]);
        }
        if (this.ccLength > 0) {
          this.mergeCells.push(...[
            //企业文化第一列合并(NO.)
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemNoColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemNoColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemNoColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemNoColIndex, rowspan: this.culPublicityLength, colspan: 1},

            //企业文化第二列合并(类别)
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemCategoryColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemCategoryColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemCategoryColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemCategoryColIndex, rowspan: this.culPublicityLength, colspan: 1},
          ]);
        }
      },
      exportExcel() {
        let param = { ScoreId: this.workId };

        let apiURL = this.$api.period.workScore.selfYearExport;
        if (this.editStatus === 'approve') {
          apiURL = this.$api.period.workScore.yearExport;
        }
        this.$ajax.get(apiURL, param, { ignore: true, responseType: 'blob' }).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result; //内容就在这里
              let json = JSON.parse(content);
              this.$message.error(json.message);
            };
            reader.readAsText(res.data);
          } else {
            const filename = `${this.summaryData.year}${this.periods[this.summaryData.period]}年计划考核表`;
            const filetype = 'xlsx';
            let data = res.data;
            let url = window.URL.createObjectURL(data);
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.href = url;
            a.download = filename + '.' + filetype;
            a.click();
            window.URL.revokeObjectURL(url);
          }
        });
      },
      goBack() {
        if (this.isCanBack) {
          this.$router.go(-1); //根据其需求，回退到指定地址
          this.$store.commit('common/backNavList', {url: this.toUrl});
        }
      }
    },
    watch: {
      kpiLength(){
        this.setMerge();
      },
      normalLength(){
        this.setMerge();
      },
      createLength(){
        this.setMerge();
      },
      hrLength(){
        this.setMerge();
      },
      ccLength(){
        this.setMerge();
      },
    }
  }
</script>
<style scoped lang='scss'>
  .year {
    height: 100%;
    .header {
      margin-top: -5px;
      .year-title {
        padding: 0 10px;
        line-height: 30px;
        h2 {
          color: $--color-text-primary;
          font-size: 18px;
          font-weight: bold;
          display: inline-block;
        }
        .saveStatus{
          margin-left: 10px;
          font-size: 15px;
          color: #8e9694;
        }
      }
    }
     ::v-deep .el-tag {
      padding: 0 10px;
      width: auto;
      text-align: center;
    }
    ::v-deep .vxe-cell {
      padding-left: 5px;
      padding-right: 5px;
    }    

    .container {
      margin-top: 15px;
      padding: 20px;
      flex: 1;
      .el-icon-arrow-down{
        font-size: 12px;
      }
      .open{
        padding: 8px 0 0 0;
        text-align: right;
        font-size: 14px;
        color: #859291;
        cursor: pointer;
      }
      .table-content{
        position: relative;
        .collapse{
          position: absolute;
          cursor: pointer;
          width: 15px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background-color: rgba(#000, 0.1);
          z-index: 99;
          &:hover{
            background-color: rgba(#000, 0.2);
          }
          i{
            font-size: 14px;
            color: #fff;
          }
        }
      }
      .search {
        overflow: auto;
        .function{
          flex-wrap: wrap;
        }
        .atb-input{
          display: flex;
          &.search-input{
            padding-top: 8px;
          }
          .flex-form-item{
            margin-bottom: 12px;
            display: flex;
            flex: 1;
          }
          .read-mode{
            align-self: flex-end;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete{
              width: 100%;
            }
          }
        }
      }
      .kpi-content {
        overflow: auto;
        flex-grow: 1;
      }
      ::v-deep .header-table {
        overflow: auto;
        flex-grow: 1;
        user-select: text;
        .vxe-table--header-wrapper {
          background-color: $--bg-color-complete !important;
        }
        .main-row {
          .vxe-cell {
            padding: 0;
          }
        }
        .weight-score .vxe-cell {
          padding-left: 5px;
          padding-right: 5px;
        }
      }
      .kpi-add {
        height: 47px;
        background-color: $--color-bg-table-header;
        color: $--color-primary;
        font-size: 14px;
        padding: 0 15px;
        div {
          cursor: pointer;
          span {
            margin-right: 15px;
          }
          i.fold {
            margin-right: 5px;
          }
        }
        span {
          cursor: pointer;
        }
      }
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
  }
   ::v-deep .el-radio-button {
    margin-right: 20px;
    margin-bottom: 15px;
    .el-radio-button__inner {
      border-radius: 20px;
      padding: 0 20px;
      width: 100%;
      line-height: 36px;
      border: 1px solid $--color-primary;
      color: $--color-primary;
    }
  }
  ::v-deep .el-radio-button.is-active .el-radio-button__inner {
    color: $--color-white;
  }
  .program-check {
    li {
      &:not(:last-child) {
        padding-bottom: 20px;
      }
      .el-checkbox__label {
        span {
          font-weight: bold;
        }
      }
      div {
        flex-grow: 1;
        margin-left: 15px;
        p {
          color: $--color-text-primary;
          font-size: 14px;
          &.desc {
            line-height: 1.5;
          }
          &.date {
            line-height: 1;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .rank-tip {
    color: $--color-primary;
  }
  .rank-tip-table {
    border-collapse: collapse;
    font-size: 13px;
    color: #222;
    td, th {
      padding: 10px ;
      border: 1px solid #ccc;
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }

</style>